import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { errorMessage } from '../helpers'

export const FETCH_NOTES = 'FETCH_NOTES'
export const FETCH_NOTES_SUCCESS = 'FETCH_NOTES_SUCCESS'
export const FETCH_NOTES_FAILURE = 'FETCH_NOTES_FAILURE'
export const SAVE_NOTES_SUCCESS = 'SAVE_NOTES_SUCCESS'
export const SAVE_NOTES_FAILURE = 'SAVE_NOTES_FAILURE'
export const NOTES_AJAX_CALL = 'NOTES_AJAX_CALL'
export const NOTES_CLEAR_AJAX_CALL = 'NOTES_CLEAR_AJAX_CALL'
export const DELETE_NOTES_SUCCESS = 'DELETE_NOTES_SUCCESS'
export const DELETE_NOTES_FAILURE = 'DELETE_NOTES_FAILURE'

export function loadNotes() {
  return (dispatch) => {
    dispatch(fetchNotes())
    axios({
      method: 'GET',
      url: URIS.notes,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(fetchNotesSuccess(res.data))
      })
      .catch((error) => {
        dispatch(fetchNotesFailure(errorMessage(error)))
      })
  }
}

function fetchNotes() {
  return {
    type: FETCH_NOTES
  }
}

function fetchNotesSuccess(payload) {
  return {
    type: FETCH_NOTES_SUCCESS,
    payload
  }
}

function fetchNotesFailure(payload) {
  return {
    type: FETCH_NOTES_FAILURE,
    payload
  }
}

export function saveNotes(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'POST',
      url: URIS.notes,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(saveNotesSuccess(res.data))
      })
      .catch((error) => {
        dispatch(saveNotesFailure(errorMessage(error)))
      })
  }
}

function saveNotesSuccess(payload) {
  return {
    type: SAVE_NOTES_SUCCESS,
    payload
  }
}

export function saveNotesFailure(payload) {
  return {
    type: SAVE_NOTES_FAILURE,
    payload
  }
}

export function deleteNotes(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'DELETE',
      url: URIS.notes,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(deleteNotesSuccess(res.data.data))
      })
      .catch((error) => {
        dispatch(deleteNotesFailure(errorMessage(error)))
      })
  }
}

function deleteNotesSuccess(payload) {
  return {
    type: DELETE_NOTES_SUCCESS,
    payload
  }
}

export function deleteNotesFailure(payload) {
  return {
    type: DELETE_NOTES_FAILURE,
    payload
  }
}

function loadingAjaxCall() {
  return {
    type: NOTES_AJAX_CALL
  }
}

export function clearAjaxCall(payload) {
  return {
    type: NOTES_CLEAR_AJAX_CALL
  }
}



// WEBPACK FOOTER //
// ./src/actions/Notes.js